import {
  faDownload,
  faTimes,
  faUpload,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { editCollectionRegister } from '../../redux/actions/form';
import { getDateTime } from '../../utility/helpers/DateTime/formatDate';

export const InputFileGroup = (props) => {
  const { name, className, title } = props;
  const dispatch = useDispatch();
  const [currFile, setFile] = useState(null);

  const openInput = (e) => {
    e.preventDefault();
    const input = document.querySelector(`[name='${name}']`);
    input.click();
  };

  const onChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setFile(file);
      dispatch(
        editCollectionRegister(['documents'], {
          name: name,
          value: {
            path: file.name,
            type: file.type,
            name: file.name,
            size: file.size,
            date: getDateTime(file.lastModifiedDate || new Date()),
            file: file,
          },
        }),
      );
    } else {
      clearInput(e);
    }
  };

  const clearInput = (e) => {
    e.preventDefault();
    setFile(null);
    dispatch(
      editCollectionRegister(['documents'], {
        name: name,
        value: {},
      }),
    );
  };

  return (
    <div className={`${className} 'mb-1'`}>
      <div></div>
      <input
        type="file"
        className="d-none"
        name={name}
        maxLength={1}
        onChange={onChange}
      />
      <div className="row">
        <div className="col-6" style={{ textAlign: 'right' }}>
          <p
            style={{
              fontWeight: 'bold',
              fontSize: '0.9rem',
              paddingTop: '3px',
            }}
          >
            {title}
          </p>
        </div>
        <div className="col-6" style={{ textAlign: 'left' }}>
          <button
            className="btn btn-sm mx-1 btn-outline-secondary"
            onClick={openInput}
            style={{ width: 'inherit' }}
          >
            {currFile ? (
              <>{currFile.name}</>
            ) : (
              <>
                {' Carga tu documento '}
                <FontAwesomeIcon icon={faUpload} />{' '}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
